import { render, staticRenderFns } from "./NotesModalOld.vue?vue&type=template&id=3727d44f&scoped=true"
import script from "./NotesModalOld.vue?vue&type=script&lang=js"
export * from "./NotesModalOld.vue?vue&type=script&lang=js"
import style0 from "./NotesModalOld.vue?vue&type=style&index=0&id=3727d44f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3727d44f",
  null
  
)

export default component.exports